module.exports = {
        srcSet: __webpack_public_path__ + "static/media/HowItWorkSection3-166.03ece5a0.webp"+" 166w",
        images: [{path: __webpack_public_path__ + "static/media/HowItWorkSection3-166.03ece5a0.webp",width: 166,height: 166}],
        src: __webpack_public_path__ + "static/media/HowItWorkSection3-166.03ece5a0.webp",
        toString: function(){return __webpack_public_path__ + "static/media/HowItWorkSection3-166.03ece5a0.webp"},
        
        width: 166,
        height: 166
      }